import { createSlice } from "@reduxjs/toolkit";

const initialActivity = {  
  date: "",
  title: "",
  explanation: "",
  sections: [],
  advisorStudents: [],
  activityTypes: []
};

const initialActivitiesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  students: [],
  activity: initialActivity
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const activitySlice = createSlice({
  name: "activities",
  initialState: initialActivitiesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getActivities
    activitiesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },    
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity.sections;
      state.activityTypes = entity.activityTypes;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.students = action.payload.entities;
    },
    // getExplanation
    explanationFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.explanation = action.payload.entity;
    },
    // getActivity
    activityFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.activity = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanExplanation
    explanationCleaned: (state) => {
      state.explanation = undefined;
    },
    // cleanStudents
    studentsCleaned: (state) => {
      state.students = [];
    },
    // cleanAttachment
    attachmentCleaned: (state) => {
      state.activity.attachmentName = null;
    },
    // cleanActivitiesState
    activitiesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.activity = initialActivity;
    }
  }
});